<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">缴费方式：</span>
        </div>
        <el-select
          v-model="paymentCode"
          filterable
          remote
          reserve-keyword
          placeholder="请选择缴费方式"
          size="small" style="width:280px"
          :remote-method="paymentRemoteMethod"
           >
           <el-option
            v-for="item in paymentList"
            :key="item.code"
            :label="item.paymentCycleName"
            :value="item.code"
            >
           </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">缴费金额：</span>
        </div>
        <el-input v-model="formData.money" disabled size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">车牌号：</span>
        </div>
        <el-input v-model="formData.carNumber" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">是否一人多车：</span>
        </div>
        <el-switch v-model="isHaveOther" active-text="是" inactive-text="否"></el-switch>
      </div>

      <div class="form-line" v-if="isHaveOther">
        <div class="textBox">
           <b class="red">*</b>
          <span class="line-text">副车车牌号：</span>
        </div>
        <div style="display: flex;justify-content: flex-start;align-items: flex-start;flex-direction: column;">
          <div v-for="(item, index) in otherCarNumberList" :key="index" style="margin-bottom: 10px;">
            <el-input v-model="item.carNumber" size="small" style="width: 280px" />
            <i class="el-icon-remove-outline" style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;" @click="removeOtherCarNumber(index)" v-if="index > 0"></i>
            <i class="el-icon-circle-plus-outline" style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;" @click="addOtherCarNumber(index)" v-if="index === otherCarNumberList.length - 1 && index<1"></i>
          </div>
        </div>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">车主姓名：</span>
        </div>
        <el-input v-model="formData.carOwnerName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">手机号：</span>
        </div>
        <el-input v-model="formData.carOwnerPhone" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">企业名称：</span>
        </div>
        <el-input v-model="formData.enterpriseName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">起始日期：</span>
        </div>
          <el-date-picker v-model="formData.enterStartDate" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" size="small" @change="changeEnterStartDate()" style="width: 280px"></el-date-picker>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">结束日期：</span>
        </div>
          <el-date-picker v-model="formData.enterEndDate" disabled type="date" value-format="yyyy-MM-dd" placeholder="开始时间" size="small" @change="changeEnterEndDate()" style="width: 280px"></el-date-picker>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">收款时间：</span>
        </div>
          <el-date-picker
            style="width:280px"
            v-model="formData.payTime"
            type="datetime"
            placeholder="选择收款时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            align="right">
          </el-date-picker>
      </div>

      <div class="form-line" v-if="formData.paymentMethod == '4'">
        <div class="textBox">
          <span class="line-text">车位号：</span>
        </div>
          <el-select
          v-model="ParkingLotCode"
          filterable
          remote
          reserve-keyword
          placeholder="请选择车位号"
          size="small" style="width: 280px"
          :remote-method="parkingLotRemoteMethod"
           >
           <el-option
            v-for="item in parkingLotList"
            :key="item.code"
            :label="item.parkLotNumber"
            :value="item.code"
            >
           </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">备注：</span>
        </div>
        <el-input type="textarea" v-model="formData.memo" size="small" style="width: 280px" />
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import md5 from "js-md5";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { api } from "../../api/ParkingService";
import { errorHandler } from "../../../utils/errorHandler";
import { bus } from "../../../utils/bus";
import { nError, nSuccess } from "../../../utils/notice";
import { pattern } from "../../../utils/regular";

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "parking-vehicle-add",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "包月车辆"
        }
      ],
      mainTitle: "添加包月车辆",
      subheading: "",

      isHaveOther: false,
      otherCarNumberList: [{ carNumber: "" }],
      formData: {
        paymentMethod: "",
        paymentCode: "",
        money: "",
        carNumber: "",
        carOwnerName: "",
        enterStartDate: "",
        enterEndDate: "",
        lotCode: "",
        isHaveOther: "0",
        otherCarNumber: ""
      },
      paymentCode: "",
      ParkingLotCode: "",
      paymentList: [],
      parkingLotList: []
    };
  },
  created() {
    this.accountCode = bus.global.accountCode;
    this.accountName = bus.global.accountName;
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let strDate = date.getDate();

    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }

    let oneYearLateYear = year + 1;
    let oneYearLateMonth = month;
    let oneYearLateDate = "";
    if (strDate > 1) {
      oneYearLateDate = strDate - 1;
    } else {
      oneYearLateMonth = month - 1;
      if (oneYearLateMonth < 10) {
        oneYearLateMonth = "0" + oneYearLateMonth;
      }
      if (oneYearLateMonth === 0) {
        oneYearLateMonth = 12;
        oneYearLateYear = year;
      }
      oneYearLateDate = new Date(
        oneYearLateYear,
        oneYearLateMonth,
        0
      ).getDate();
    }
    if (oneYearLateDate >= 0 && oneYearLateDate <= 9) {
      oneYearLateDate = "0" + oneYearLateDate;
    }
    this.formData.enterStartDate = `${year}-${month}-${strDate}`;
    this.formData.enterEndDate = `${oneYearLateYear}-${oneYearLateMonth}-${oneYearLateDate}`;

    this.paymentRemoteMethod();
    this.parkingLotRemoteMethod();
  },
  mounted() {
    this.changePickerOptions1();
  },
  methods: {
    toMonthlyVehiclePage() {
      this.$router.push({
        name: "monthly-vehicle"
      });
    },
    changePickerOptions1() {
      let enterStartDateTime =
        new Date(this.formData.enterStartDate).getTime() - 3600 * 24 * 1000;
      this.pickerOptions1 = {
        disabledDate(time) {
          return time.getTime() < enterStartDateTime;
        }
      };
    },
    changePickerOptions2() {
      let enterEndDateTime = new Date(this.formData.enterEndDate).getTime();
      this.pickerOptions2 = {
        disabledDate(time) {
          return time.getTime() > enterEndDateTime;
        }
      };
    },
    changeEnterStartDate() {
      this.changePickerOptions1();
    },
    changeEnterEndDate() {
      this.changePickerOptions2();
    },
    paymentRemoteMethod(query) {
      this.$axios
        .post(api.getParkingPaymentConfigList, {
          searchKey: query,
          configType: 2
        })
        .then(res => {
          if (res.data.retCode === 1) {
            // console.log(res);
            let data = res.data.data;
            data.map(v => {
              if (v.paymentCycle === "1") {
                v.paymentCycleName = "月付";
              } else if (v.paymentCycle === "2") {
                v.paymentCycleName = "季付";
              } else if (v.paymentCycle === "3") {
                v.paymentCycleName = "半年付";
              } else {
                v.paymentCycleName = "年付";
              }
            });
            this.paymentList = data;
            console.log(this.paymentList);
          }
        })
        .catch(errorHandler("获取缴费列表失败"));
    },
    parkingLotRemoteMethod(query) {
      this.$axios
        .post(api.getFixedUnBindLot, {
          searchKey: query
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            this.parkingLotList = data;
            console.log(this.parkingLotList);
          }
        })
        .catch(errorHandler("获取车位管理失败"));
    },

    addOtherCarNumber(index) {
      if (!this.otherCarNumberList[index].carNumber) {
        nError("请先输入当前副车车牌号");
        return false;
      }
      let obj = { carNumber: "" };
      this.otherCarNumberList.push(obj);
    },

    removeOtherCarNumber(index) {
      this.otherCarNumberList.splice(index, 1);
    },

    confirm() {
      if (!this.formData.carOwnerName) {
        nError("请输入车主姓名");
        return false;
      }
      if (!this.formData.money) {
        nError("请选择缴费方式");
        return false;
      }
      if (!this.formData.payTime) {
        nError("请选择收款时间");
        return false;
      }
      if (!this.formData.carNumber) {
        nError("请输入车牌号");
        return false;
      }
      if (this.isHaveOther && this.otherCarNumberList[0].carNumber === "") {
        nError("请输入副车车牌号");
        return false;
      }
      let otherCarNumber = [];
      this.otherCarNumberList.map(car => {
        if (car.carNumber) {
          otherCarNumber.push(car.carNumber);
        }
      });
      this.formData.isHaveOther = this.isHaveOther ? "1" : "0";
      this.formData.otherCarNumber = otherCarNumber.join(",");
      this.formData.money = this.formData.money.toString();
      this.$axios
        .post(api.addByManager, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("添加成功");
            this.toMonthlyVehiclePage();
          }
        })
        .catch(errorHandler("添加失败"));
    },
    cancel() {
      this.toMonthlyVehiclePage();
    },

    changeTime() {
      if (this.formData.paymentMethod == "1") {
        let nowDate = new Date(this.formData.enterStartDate);
        let yyyy = nowDate.getFullYear();
        let mm = nowDate.getMonth() + 1 < 10 ? "0" + (nowDate.getMonth() + 1) : nowDate.getMonth() + 1;
        let dd = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
        let enterStartDate = `${yyyy}-${mm}-${dd}`;
        let YYYY = "";
        let MM = "";
        let DD = "";
        if (mm == 12) {
          if (dd == '01') {
            MM = mm
            YYYY = yyyy;
          } else {
            MM = "01"
            YYYY = yyyy + 1;
          }
        } else {
          YYYY = yyyy;
          if (dd == '01') {
            MM = +mm < 10 ? "0" + (+mm) : +mm;
          } else {
            MM = +mm + 1 < 10 ? "0" + (+mm + 1) : +mm + 1;
          }
        }
        if (dd == "01") {
          if (mm == "01" || mm == "03" || mm == "05" || mm == "07" || mm == "08" || mm == "10" || mm == "12") {
            DD = "31";
            MM = +mm < 10 ? "0" + +mm : +mm;
          } else if (mm == "02") {
            if (yyyy % 4 == 0 || yyyy % 400 == 0) {
              DD = "29";
            } else {
              DD = "28";
            }
          } else {
            DD = "30";
          }
        } else {
          DD = dd - 1;
        }
        if ((mm == "01" && dd == "31" && yyyy % 4 == 0) || yyyy % 400 == 0) {
          YYYY = yyyy;
          MM = "03";
          DD = "01";
        } else if (mm == "01" && dd == "31" && yyyy % 4 != 0) {
          YYYY = yyyy;
          MM = "03";
          DD = "02";
        }
        if ((mm == "01" && dd == "30" && yyyy % 4 == 0) || yyyy % 400 == 0) {
          YYYY = yyyy;
          MM = "02";
          DD = "29";
        } else if (mm == "01" && dd == "30" && yyyy % 4 != 0) {
          YYYY = yyyy;
          MM = "03";
          DD = "01";
        }
        DD = DD < 10 ? "0" + DD : DD;
        let enterEndDate = `${YYYY}-${MM}-${DD}`;
        this.formData.enterEndDate = enterEndDate;
      } else if (this.formData.paymentMethod == "2") {
        let nowDate = new Date(this.formData.enterStartDate);
        let yyyy = nowDate.getFullYear();
        let mm =
          nowDate.getMonth() + 1 < 10
            ? "0" + (nowDate.getMonth() + 1)
            : nowDate.getMonth() + 1;
        let dd =
          nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
        let enterStartDate = `${yyyy}-${mm}-${dd}`;
        let dt = new Date(yyyy, mm - 1, dd);
        dt.setMonth(dt.getMonth() + 3);
        dt.setDate(dt.getDate() - 1);
        let yyyy2 = dt.getFullYear();
        let mm2 =
          dt.getMonth() + 1 < 10
            ? "0" + (dt.getMonth() + 1)
            : dt.getMonth() + 1;
        let dd2 = dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate();
        let enterEndDate = `${yyyy2}-${mm2}-${dd2}`;
        this.formData.enterEndDate = enterEndDate;
      } else if (this.formData.paymentMethod == "3") {
        let nowDate = new Date(this.formData.enterStartDate);
        let yyyy = nowDate.getFullYear();
        let mm =
          nowDate.getMonth() + 1 < 10
            ? "0" + (nowDate.getMonth() + 1)
            : nowDate.getMonth() + 1;
        let dd =
          nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
        let enterStartDate = `${yyyy}-${mm}-${dd}`;
        let dt = new Date(yyyy, mm - 1, dd);
        dt.setMonth(dt.getMonth() + 6);
        dt.setDate(dt.getDate() - 1);
        let yyyy2 = dt.getFullYear();
        let mm2 =
          dt.getMonth() + 1 < 10
            ? "0" + (dt.getMonth() + 1)
            : dt.getMonth() + 1;
        let dd2 = dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate();
        let enterEndDate = `${yyyy2}-${mm2}-${dd2}`;
        this.formData.enterEndDate = enterEndDate;
      } else if (this.formData.paymentMethod == "4") {
        let nowDate = new Date(this.formData.enterStartDate);
        let yyyy = nowDate.getFullYear();
        let mm =
          nowDate.getMonth() + 1 < 10
            ? "0" + (nowDate.getMonth() + 1)
            : nowDate.getMonth() + 1;
        let dd =
          nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
        let enterStartDate = `${yyyy}-${mm}-${dd}`;
        let dt = new Date(yyyy, mm - 1, dd);
        dt.setMonth(dt.getMonth() + 12);
        dt.setDate(dt.getDate() - 1);
        let yyyy2 = dt.getFullYear();
        let mm2 =
          dt.getMonth() + 1 < 10
            ? "0" + (dt.getMonth() + 1)
            : dt.getMonth() + 1;
        let dd2 = dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate();
        let enterEndDate = `${yyyy2}-${mm2}-${dd2}`;
        this.formData.enterEndDate = enterEndDate;
      }
    }
  },
  watch: {
    paymentCode(val) {
      this.paymentList.map(v => {
        if (v.code === val) {
          console.log(v);
          this.formData.paymentCode = v.code;
          this.formData.money = v.unitPrice;
          this.formData.paymentMethod = v.paymentCycle;
          this.changeTime();
        }
      });
    },
    ParkingLotCode(val) {
      this.parkingLotList.map(v => {
        if (v.code === val) {
          this.formData.lotCode = v.code;
          this.formData.lotNumber = v.parkLotNumber;
        }
      });
    },
    "formData.enterStartDate"() {
      this.changeTime();
    }
  }
};
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
}
.form-line {
  margin: 20px 0;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
</style>

<style scoped lang="less">
/deep/.el-input__inner {
  height: 30px !important;
  line-height: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/MonthlyVehicle/MonthlyVehicleAdd.vue